import {GetterTree} from "vuex";
import {FinanceState} from "@/store/finance/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<FinanceState, RootState> = {
  balances:state => state.balances ?? [],
  overdrafts:state => state.overdrafts ?? [],
}